<!-- Navbar -->
<nav class="navbar navbar-expand-xl navbar-light bg-light">
    <!-- Container wrapper -->
    <div class="container-fluid">
        <!-- Navbar brand -->
        <a class="navbar-brand navbar-brand-logo outline-none" routerLink="/client-profile">
            <div class="logo">
                <img src="assets/images/new-logo.png" class="h-100" alt="Ledger Sync">
            </div>
        </a>


        <ul class="navbar-nav mb-2 mb-lg-0">
            <li class="nav-item">
                <a
                        class="nav-link shadow-none"
                        [ngClass]="{'position-relative': true}"
                        role="button"
                        routerLinkActive="active"
                        id="task-center"
                        [routerLinkActiveOptions]="{ exact: false }"
                        routerLink="/task-center"
                >
                    Task Center
                    @if (taskCenterEventCount() > 0) {
                        <span class="position-absolute task-center-notification-badge"></span>
                    }
                </a>
            </li>
        </ul>

        <div class="d-flex align-items-center ms-auto overflow-hidden">
            <language-switcher></language-switcher>
            <div dropdown class="nav-item dropdown ms-2 overflow-hidden" container="body" placement="bottom right">
                <div
                        class="nav-link dropdown-toggle d-flex align-items-center"
                        id="userLink"
                        role="button"
                        dropdownToggle
                        aria-expanded="false"
                >
                    <i class="fa fa-user me-1"></i>
                    <div title="{{currentUser.fullName}}"
                         class="text-ellipsis mw-200px">{{ currentUser.fullName }}
                    </div>
                </div>
                <ul
                        *dropdownMenu
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="userLink"
                >
                    <li>
                        <a class="dropdown-item" routerLink="/change-password">
                            <i class="me-2 fa fa-key"></i>{{ 'Change Password'|translate }}
                        </a>
                    </li>

                    <li>
                        <hr class="dropdown-divider"/>
                    </li>
                    <li>
                        <a class="dropdown-item" href="https://ledgersync.com/legal/terms" target="_blank">
                            <i class="me-2 fa fa-gavel"></i>{{ 'Terms & Conditions'|translate }}
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" href="mailto:support@ledgersync.com">
                            <i class="me-2 fa fa-envelope"></i>{{ 'Contact us'|translate }}
                        </a>
                    </li>
                    <!--                    <li>-->
                    <!--                        <a class="dropdown-item" [href]="banksListUrl">-->
                    <!--                            <i class="me-2 fa-solid fa-building-columns"></i>{{'Supported Banks'|translate}}-->
                    <!--                        </a>-->
                    <!--                    </li>-->

                    <li>
                        <a class="dropdown-item"
                           href="https://developer.mastercard.com/open-banking-us/documentation/financial-institution/supported-institutions/"
                           target="_blank">
                            <i class="me-2 fa-solid fa-building-columns"></i>{{ 'Mastercard Supported Banks'|translate }}
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" (click)="requestNewBank()">
                            <i class="me-2 fa-solid fa-building-columns"></i>{{ 'Request New Bank'|translate }}
                        </a>
                    </li>
                    <li>
                        <hr class="dropdown-divider"/>
                    </li>
                    <li class="cursor-pointer" (click)="logout()">
                        <span class="dropdown-item">Logout</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Container wrapper -->
</nav>
<!-- Navbar -->
